import { SeatPriceMap as SeatPriceMapType } from '@/src/types/itinerary'
import { TranslationFunction } from '@/src/types/translations'
import SeatPriceMap from './seatPriceMap'

const SeatPriceMapWrapper = ({
    seatPriceMap,
    formatCurrency,
    t
}: {
    seatPriceMap: SeatPriceMapType[]
    formatCurrency: (price: number) => string
    t: TranslationFunction<'itineraryPage.addons'>
}) => {
    return <SeatPriceMap seatPriceMap={seatPriceMap} formatCurrency={formatCurrency} t={t} />
}

export default SeatPriceMapWrapper
